import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import { FileUpload } from "primereact/fileupload";
import "./Clients.css";
import Resizer from "react-image-file-resizer";

function Clients() {
  let emptyClients = {
    id: null,
    name: "",
    sortOrder: "",
    imageUrl: null,
  };
  const [Clients, setClients] = useState(null);

  const [ClientsDialog, setClientsDialog] = useState(false);
  const [DeleteClientDialog, setDeleteClientDialog] = useState(false);
  const [DeleteClientsDialog, setDeleteClientsDialog] = useState(false);
  const [client, setClient] = useState(emptyClients);
  const [selectedClients, setSelectedClients] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);
  const [file, setFile] = useState(null);

  const isFetched = useRef(false); // ✅ Prevent duplicate API calls

  useEffect(() => {
    if (!isFetched.current) {
      getClients();
      isFetched.current = true; // ✅ Ensure it runs only once
    }
  }, []);

  const getClients = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/Clients"
      );

      if (response.data) {
        setClients(response.data);
      }
    } catch (error) {
      console.error("Error fetching Clients:", error);
    }
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        800, // width
        800, // height
        "JPEG", // format (can be "JPEG", "PNG", "WEBP")
        80, // quality (0-100)
        0, // rotation (optional)
        (uri) => {
          resolve(uri);
        },
        "blob" // output type (blob or base64)
      );
    });
  const openNew = () => {
    setClient(emptyClients);
    setSubmitted(false);
    setClientsDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setClientsDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteClientDialog(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteClientsDialog(false);
  };

  const saveClient = async () => {
    setLoading(true);
    setSubmitted(true);

    try {
      if (client.name.trim()) {
        let _Clients = [...Clients];
        let _Client = { ...client };

        if (client.id) {
          const index = findIndexById(client.id);

          let formData = new FormData();
          formData.append("name", _Client.name);
          formData.append("sortOrder", _Client.sortOrder);
          if (file != null) {
            formData.append("image", file);
          }

          const response = await axios.put(
            process.env.REACT_APP_BACKEND_URL + "api/Clients/" + client.id,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );

          setFile(null);

          if (response.data.success) {
            _Clients[index] = _Client;
            if (response.data.fileName !== "")
              _Clients[index].imageUrl = response.data.fileName;

            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Icon Updated",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Icon Not Updated",
              life: 3000,
            });
          }
        } else {
          _Client.id = createId();

          let formData = new FormData();
          formData.append("name", _Client.name);
          formData.append("sortOrder", _Client.sortOrder);
          if (file != null) {
            formData.append("image", file);
          }

          const response = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "api/Clients",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );

          setLoading(false);
          setFile(null);

          if (response.data.success) {
            _Clients.push(response.data.client);

            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Client Added",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Client Not Added",
              life: 3000,
            });
          }
        }

        setClients(_Clients);
        setClientsDialog(false);
        setClient(emptyClients);
      }
    } catch (error) {
      console.error("Error during save operation:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          "An error occurred while saving the client. Please try again later.",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const editProduct = (client) => {
    setClient({ ...client });
    setClientsDialog(true);
  };

  const confirmDeleteProduct = (client) => {
    setClient(client);
    setDeleteClientDialog(true);
  };

  const deleteProduct = async () => {
    setLoading(true);
    const response = await axios.delete(
      process.env.REACT_APP_BACKEND_URL + "api/Clients/" + client.id
    );
    setLoading(false);
    if (response.data.success) {
      let _Clients = Clients.filter((val) => val.id !== client.id);
      setClients(_Clients);
      setDeleteClientDialog(false);
      setClient(emptyClients);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Project Icon Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Project Icon Not Deleted",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < Clients.length; i++) {
      if (Clients[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const imageBodyTemplate = (rowData) => {
    return (
      <img
        loading="lazy"
        src={process.env.REACT_APP_BACKEND_URL_IMAGES + rowData.imageUrl}
        alt={rowData.imageUrl}
        className="shadow-2 border-round"
        style={{ width: "64px" }}
      />
    );
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteClientsDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedClients.map((client) => client.id);
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "api/Clients/DeleteClientsByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _Clients = Clients.filter((val) => !selectedClients.includes(val));
      setClients(_Clients);
      setDeleteClientsDialog(false);
      setSelectedClients(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Icons Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Icons Not Deleted",
        life: 3000,
      });
    }
  };

  const onFileUpload = async (event) => {
    setLoading(true);
    const file = event.files[0];

    const resizedImage = await resizeFile(file); // Resize the image

    // Create a new File from the blob with the correct name and MIME type
    const newFile = new File([resizedImage], file.name, {
      type: resizedImage.type || "image/jpeg", // Set MIME type
    });
    setFile(newFile);
    //setFile(file);

    setClient((prevClient) => ({
      ...prevClient,
      image: process.env.REACT_APP_BACKEND_URL_IMAGES + newFile.name, // Save the file name as the image path for simplicity
    }));
    setLoading(false);
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _Client = { ...client };

    _Client[`${name}`] = val;

    setClient(_Client);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage Clients</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={!selectedClients || !selectedClients.length}
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Project Icons</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button label="Cancel" icon="pi pi-times" outlined onClick={hideDialog} />
      <Button
        label="Save"
        loading={loading}
        icon="pi pi-check"
        onClick={saveClient}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );

  return (
    <div className="col-12">
      <div className="client-container">
        <Toast ref={toast} />
        <div className="card">
          <Toolbar
            className="mb-3"
            start={leftToolbarTemplate}
            end={rightToolbarTemplate}
          ></Toolbar>

          <DataTable
            ref={dt}
            value={Clients}
            selection={selectedClients}
            onSelectionChange={(e) => setSelectedClients(e.value)}
            dataKey="id"
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 25]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Project Icons"
            globalFilter={globalFilter}
            header={header}
          >
            <Column selectionMode="multiple" exportable={false}></Column>
            <Column
              field="id"
              header="Code"
              sortable
              width="150px"
              style={{ textAlign: "center" }}
            ></Column>

            <Column
              field="name"
              header="Name"
              sortable
              style={{ minWidth: "12rem" }}
            ></Column>
            <Column
              field="imageUrl"
              header="Image"
              body={imageBodyTemplate}
            ></Column>

            <Column
              field="sortOrder"
              header="Order"
              sortable
              style={{ textAlign: "center" }}
            ></Column>

            <Column
              body={actionBodyTemplate}
              exportable={false}
              style={{ minWidth: "12rem" }}
            ></Column>
          </DataTable>
        </div>

        <Dialog
          visible={ClientsDialog}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="Client Details"
          modal
          className="p-fluid"
          footer={productDialogFooter}
          onHide={hideDialog}
        >
          {client.imageUrl && (
            <div className="image-container">
              <img
                loading="lazy"
                src={process.env.REACT_APP_BACKEND_URL_IMAGES + client.imageUrl}
                alt={client.name}
                className="product-image block m-auto pb-3"
              />
            </div>
          )}
          <div className="field">
            <label htmlFor="name" className="font-bold mb-1">
              Name :
            </label>
            <InputText
              id="name"
              value={client.name}
              onChange={(e) => onInputChange(e, "name")}
              required
              className={classNames({
                "p-invalid": submitted && !client.name,
              })}
            />
            {submitted && !client.name && (
              <small className="p-error">Name is required.</small>
            )}
          </div>
          <div className="field">
            <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
              Order :
            </label>
            <InputText
              id="sortOrder"
              type="number"
              value={client.sortOrder}
              onChange={(e) => onInputChange(e, "sortOrder")}
              required
              className={classNames({
                "p-invalid": submitted && !client.sortOrder,
              })}
            />
            {submitted && !client.sortOrder && (
              <small className="p-error">Sort Order is required.</small>
            )}
          </div>

          <div className="field">
            <label htmlFor="image" className="mt-3 mb-1 font-bold">
              Image :
            </label>
            <FileUpload
              name="image"
              mode="basic"
              accept="image/*"
              onSelect={onFileUpload}
            />
          </div>
        </Dialog>

        <Dialog
          visible={DeleteClientDialog}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="Confirm"
          modal
          footer={deleteProductDialogFooter}
          onHide={hideDeleteProductDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle mr-3"
              style={{
                textAlign: "center",
                fontSize: "2rem",
                width: "100%",
                color: "#6659ff",
              }}
            />
            <div>
              <p style={{ textAlign: "center", marginBottom: "5px" }}>
                Are you sure you want to delete:
              </p>
              {client && (
                <p style={{ textAlign: "center", marginBottom: "0" }}>
                  <b>{client.name}</b>
                </p>
              )}
            </div>
          </div>
        </Dialog>

        <Dialog
          visible={DeleteClientsDialog}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="Confirm"
          modal
          footer={deleteProductsDialogFooter}
          onHide={hideDeleteProductsDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle mr-3"
              style={{
                textAlign: "center",
                fontSize: "2rem",
                width: "100%",
                color: "#6659ff",
              }}
            />
            {client && (
              <p
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  marginBottom: "25px",
                }}
              >
                Are you sure you want to delete the selected Clients?
              </p>
            )}
          </div>
        </Dialog>
      </div>
    </div>
  );
}

export default Clients;
